import type { Product } from '@nf/types/product';
import { AccountActStatus } from '@nf/utils-common/constants';
import { sportService } from '@/services/sport.service';


export const thirdPartyProducts: Array<Product> = [
	{
		productName: 'exchange',
		image: {
			href: '/images/home/nav/icon_exchange.webp',
		},
		resourceKey: 'lbl_Exchange',
		enableCondition: ({ user }) => user?.Exchange !== 0,
	},
	{
		productName: 'predictionMarket',
		image: {
			href: '/images/home/nav/icon_prediction-market.webp',
		},
		resourceKey: 'lbl_PredictMarket',
		enableCondition: ({ canSeePredictionMarket }) =>
			canSeePredictionMarket,
	},
	{
		productName: 'casinoRoyale',
		image: {
			href: '/images/home/nav/icon_casinoroyale.webp',
		},
		resourceKey: 'lbl_SabaSel',
		enableCondition: ({ user, canSeeCasinoRoyale }) =>
			canSeeCasinoRoyale && user?.ActStatus === AccountActStatus.Deposited,
	},
	{
		productName: 'advantplay',
		image: {
			href: '/images/home/nav/icon_advantplay.webp',
		},
		resourceKey: 'lbl_Advantplay',
		enableCondition: ({ user, canSeeAdvantPlayVendorLobby }) =>
			canSeeAdvantPlayVendorLobby && user?.ActStatus === AccountActStatus.Deposited,
	},
	{
		productName: 'sabaScore',
		image: {
			href: '/images/home/nav/icon_score.webp',
		},
		resourceKey: 'lbl_Sabaicon_Lic',
		enableCondition: ({ enableSabaScore }) => enableSabaScore,
	},
	{
		productName: 'numberGame',
		image: {
			href: '/images/home/nav/icon_numbergame.webp',
		},
		resourceKey: 'lbl_161',
		subProducts: [
			{
				productName: 'classicNumberGame',
				GameId: 'lottery161',
				GlobalResourceLabel: 'lbl_ClassicNG',
				RouteTarget: '/sports/161',
				enableCondition: ({ user, forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('161') && available3rdPartyGames.includes(161) && user?.NG !== 0,
			},
			{
				productName: 'speedNumberGame',
				GameId: 'lottery161-2',
				GlobalResourceLabel: 'lbl_SpdNG',
				RouteTarget: '/sports/161',
				enableCondition: ({ user, forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('161') && available3rdPartyGames.includes(161) && user?.NG !== 0,
			},
			{
				productName: 'happy5',
				GameId: 'lottery164',
				GlobalResourceLabel: 'lbl_164',
				RouteTarget: '/sports/164',
				enableCondition: ({ user, forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('164') && available3rdPartyGames.includes(164) && user?.Happy5 !== 0,
			}
		]
	},
	{
		productName: 'virtualSports', // was called 'virtuals' in lite
		image: {
			href: '/images/home/nav/icon_virtualsports.webp',
		},
		resourceKey: 'lbl_VirtualSport',
		subProducts: [
			{
				productName: 'beter',
				GameId: 'virtual112',
				GlobalResourceLabel: 'lbl_112',
				RouteTarget: '/sports/112/t',
				enableCondition: ({ forbiddenSport, available3rdPartyGames, enableESoccerBattle }) =>
					!forbiddenSport.includes('112') &&
					available3rdPartyGames.includes(112) &&
					enableESoccerBattle,
			},
			{
				productName: 'virtualSteepleChase',
				GameId: 'virtual125',
				GlobalResourceLabel: 'lbl_125',
				RouteTarget: '/sports/125',
				enableCondition: ({ user, forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('125') && 
					available3rdPartyGames.includes(125) && 
					user?.ActStatus === AccountActStatus.Deposited,
			},
			{
				productName: 'virtualHarnessRacing',
				GameId: 'virtual126',
				GlobalResourceLabel: 'lbl_126',
				RouteTarget: '/sports/126',
				enableCondition: ({ user, forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('126') && 
					available3rdPartyGames.includes(126) && 
					user?.ActStatus === AccountActStatus.Deposited,
			},
			{
				productName: 'virtualMotorRacing',
				GameId: 'virtual127',
				GlobalResourceLabel: 'lbl_127',
				RouteTarget: '/sports/127',
				enableCondition: ({ user, forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('127') && 
					available3rdPartyGames.includes(127) && 
					user?.ActStatus === AccountActStatus.Deposited,
			},
			{
				productName: 'betby',
				GameId: 'virtual134',
				GlobalResourceLabel: 'lbl_NBA2K',
				RouteTarget: '/sports/134',
				enableCondition: ({ forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('134') && available3rdPartyGames.includes(134),
			},
			{
				productName: 'betbyESoccer',
				GameId: 'virtual116',
				GlobalResourceLabel: 'lbl_BetbyEsoccerPopup03',
				RouteTarget: '/sports/116',
				enableCondition: ({ forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('116') && available3rdPartyGames.includes(116),
			},
			{
				productName: 'virtuallySoccer',
				GameId: 'virtual147',
				GlobalResourceLabel: 'lbl_147',
				RouteTarget: '/sports/147/t',
				enableCondition: ({ forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('147') && available3rdPartyGames.includes(147),
			},
			{
				productName: 'virtualHorseRacing',
				GameId: 'virtual198',
				GlobalResourceLabel: 'lbl_198',
				RouteTarget: '/sports/198',
				enableCondition: ({ user, forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('198') && 
					available3rdPartyGames.includes(198) && 
					user?.ActStatus === AccountActStatus.Deposited,
			},
			{
				productName: 'virtualDogRacing',
				GameId: 'virtual177',
				GlobalResourceLabel: 'lbl_177',
				RouteTarget: '/sports/177',
				enableCondition: ({ user, forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('177') && 
					available3rdPartyGames.includes(177) && 
					user?.ActStatus === AccountActStatus.Deposited,
			},
			{
				productName: 'virtualFootballLeague',
				GameId: 'virtual179',
				GlobalResourceLabel: 'lbl_179',
				RouteTarget: '/sports/179',
				enableCondition: ({ forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('179') && available3rdPartyGames.includes(179),
			},
			{
				productName: 'soccerBundesliga',
				GameId: 'virtual195',
				GlobalResourceLabel: 'lbl_195',
				RouteTarget: '/sports/195',
				enableCondition: ({ forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('195') && available3rdPartyGames.includes(195),
			},
			{
				productName: 'soccerEuroCup',
				GameId: 'virtual197',
				GlobalResourceLabel: 'lbl_197',
				RouteTarget: '/sports/197',
				enableCondition: ({ user, forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('197') && available3rdPartyGames.includes(197) && user?.VSEC !== 0,
			},
			{
				productName: 'soccerChampionsCup',
				GameId: 'virtual196',
				GlobalResourceLabel: 'lbl_196',
				RouteTarget: '/sports/196',
				enableCondition: ({ user, forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('196') && available3rdPartyGames.includes(196) && user?.VSCC !== 0,
			},
			{
				productName: 'soccerAsianCup',
				GameId: 'virtual194',
				GlobalResourceLabel: 'lbl_194',
				RouteTarget: '/sports/194',
				enableCondition: ({ user, forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('194') && available3rdPartyGames.includes(194) && user?.VSAC !== 0,
			},
			{
				productName: 'soccerLeague',
				GameId: 'virtual190',
				GlobalResourceLabel: 'lbl_190',
				RouteTarget: '/sports/190',
				enableCondition: ({ forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('190') && available3rdPartyGames.includes(190),
			},
			{
				productName: 'soccerWorldCup',
				GameId: 'virtual192',
				GlobalResourceLabel: 'lbl_192',
				RouteTarget: '/sports/192',
				enableCondition: ({ user, forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('192') && available3rdPartyGames.includes(192) && user?.VRS !== 0,
			},
			{
				productName: 'soccerNation',
				GameId: 'virtual191',
				GlobalResourceLabel: 'lbl_191',
				RouteTarget: '/sports/191',
				enableCondition: ({ forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('191') && available3rdPartyGames.includes(191),
			},
			{
				productName: 'virtualSoccer',
				GameId: 'virtual180',
				GlobalResourceLabel: 'lbl_180',
				RouteTarget: '/sports/180',
				enableCondition: ({ forbiddenSport, available3rdPartyGames, virtualSoccerList }) =>
					!forbiddenSport.includes('180') &&
					available3rdPartyGames.some((gameId) =>
						sportService.shouldGroupVirtualSoccerMenuFace(gameId, virtualSoccerList)
					),
			},
			{
				productName: 'virtualBasketball',
				GameId: 'virtual193',
				GlobalResourceLabel: 'lbl_193',
				RouteTarget: '/sports/193',
				enableCondition: ({ forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('193') && available3rdPartyGames.includes(193),
			},
			{
				productName: 'virtualTennis',
				GameId: 'virtual186',
				GlobalResourceLabel: 'lbl_186',
				RouteTarget: '/sports/186',
				enableCondition: ({ forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('186') && available3rdPartyGames.includes(186),
			},
			{
				productName: 'virtualCockFighting',
				GameId: 'virtual188',
				GlobalResourceLabel: 'lbl_188',
				RouteTarget: '/sports/188',
				enableCondition: ({ forbiddenSport, available3rdPartyGames }) => 
					!forbiddenSport.includes('188') && available3rdPartyGames.includes(188),
			},
		]
	}
];